import core from '../../../js/core/core'

import * as types from '../mutation-types'
import EventBus from '@/vue/events/event-bus'

// initial state
const state = {
  arr_selectedTemplate: {},
  arr_breadcumb: [],
}

// getters
const getters = {
  arr_selectedTemplate: state => state.arr_selectedTemplate,
  arr_breadcumb: state => state.arr_breadcumb,
}

// actions
const actions = {
  
  changeTemplate(context, payload){
    // selectedTemplate -> subtemplate is to detect HDP/OU , parlay , outright page
    payload.int_marketToggle = this.getters.int_marketToggle
    this.commit('ARR_BREADCUMB', payload)
    var params = {
      templateId : payload.templateId,
      bettypeid: payload.bettypeid,
      sportId: payload.sportId,
      marketKey: payload.marketKey,
      plytype: payload.plytype,
      int_marketToggle: this.getters.int_marketToggle,
      subTemplateId: payload.subTemplateId,
      date: payload.date,
    }
    if(payload.eveid) {
      params.eveid = payload.eveid
    }
    
    this.commit('SELECTED_TEMPLATE', params)
    this.commit('SELECTED_MARKET', payload.marketKey)
    this.commit('SHOW_LEDGER', false)
    
  },
  redirectReturn (context, payload) {
    this.commit('ARR_BREADCUMB', {
      return: true
    })
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
}

// mutations
const mutations = {
  [types.SELECTED_TEMPLATE] (state, payload ) {
    state.arr_selectedTemplate = payload
  },

  [types.ARR_BREADCUMB] (state, payload ) {
    if(payload.return) {
      state.arr_breadcumb.splice(-1,1)
      if(state.arr_breadcumb.length == 0){
        if(this.getters.account.previewFlag == true){
          location.href="preview?authtoken="+window.authtoken
        }else{
          location.href="home?authtoken="+window.authtoken
        }
        
        return
      }
      if(state.arr_breadcumb[state.arr_breadcumb.length - 1]['templateId'] == '18'){
        location.href="home?authtoken="+window.authtoken
        return
      }
      if(state.arr_breadcumb.length == 0 ) {
        state.arr_selectedTemplate = {
          templateId: 1
        }
        this.dispatch('getEventList', {
          market: 3
        })
        this.commit('MARKETTOGGLE', '3')
      } else {
        state.arr_selectedTemplate = state.arr_breadcumb[state.arr_breadcumb.length - 1]
        if(state.arr_breadcumb[state.arr_breadcumb.length - 1].int_marketToggle) {
          this.commit('MARKETTOGGLE', state.arr_breadcumb[state.arr_breadcumb.length - 1].int_marketToggle)
        }
        this.commit('MARKET_BUTTON_TOGGLE',false)
        this.commit('IS_RESULT_SCHEDULE',false)
    
        //call eventbus $emit based on template
        if(state.arr_selectedTemplate.templateId == '2') {
          var date = state.arr_selectedTemplate.int_marketToggle == "1" || state.arr_selectedTemplate.int_marketToggle == "3" ? 0 : 99
          this.commit('SELECTED_PAYLAY_DATE', date)
          EventBus.$emit('refreshLeague')
          EventBus.$emit('refreshSportHeaderSelection')
        } else if(state.arr_selectedTemplate.templateId == '3'){
          EventBus.$emit('refreshSportTable')
        } else if(state.arr_selectedTemplate.templateId == '4') {
          EventBus.$emit('refreshEvents')
        } else if (state.arr_selectedTemplate.templateId == '5') {
          EventBus.$emit('refreshSportOutrightTable')
        } else if (state.arr_selectedTemplate.templateId == '6') {
          EventBus.$emit('refreshAllBet')
        }
      }
    } else {
      history.pushState(null, null, location.href);
      state.arr_breadcumb.push(payload)
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/score/vue/store/modules/breadcumb.js